import { s, spacing } from '@/theme/tokens';

export const metricTrendCardCompactLayout = {
  minHeight: 76,
  chartHeight: 18,
  hideCornerIconBelowWidth: 480,
  headerPaddingX: s('md'),
  headerPaddingTop: s('sm'),
  headerPaddingBottom: s('none'),
  middleGridTemplateColumns: 'max-content minmax(0, 1fr)',
  middleColumnGap: s('sm'),
  middlePaddingY: s('xs'),
  valuePaddingX: s('md'),
  valuePaddingRight: s('none'),
  valuePaddingY: s('xxs'),
  chartPaddingX: s('none'),
  chartPaddingLeft: s('none'),
  footerPaddingX: s('md'),
  footerPaddingTop: s('none'),
  footerPaddingBottom: s('sm'),
  rowGap: s('lg'),
  rowGapPx: spacing.lg,
} as const;
